<script>
    import Status from './Status.svelte';
    import { slide, blur } from 'svelte/transition';
    import { quintIn } from 'svelte/easing';
    let form,
    name = '',
    email = '',
    message = '',
    btnDisabled = false,
    nameLenth = 3,
    messageLenth = 10,
    error = {
        'NameMassage': null,
        'EmailMassage': null,
        'Message': null
    },   
    isSubmited = false,
    isSubmissionError = false,
    handleSubmit = () => {
        let formData = new FormData();
        formData.append( "n", name );
        formData.append( "e", email );
        formData.append( "m", message );
        submitForm(formData);
    },
    setErrors = () => {
        if (name.trim().length < nameLenth) error.NameMassage = `Name should be at least ${nameLenth} characters`;
        if (!validateEmail()) error.EmailMassage = 'Invalid email format';
        if (message.trim().length < messageLenth) error.Message = `Message should be at least ${messageLenth} characters`;
    },
    areErrors = () => {
        setErrors();

        let areErrors = Object.keys(error).filter( key => { 
            return error[key] !== null;
        });
        if (areErrors.length === 0) {
            return false
        }
        
        return true
    },
    handleName = () => {
        if (name.trim().length < nameLenth) {
            error.NameMassage = `Name should be at least ${nameLenth} characters`;
        } else {
            error.NameMassage = null;
        }
    },
    validateEmail = () => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    },
    handleEmail = () => {   
        if (!validateEmail()) {
            error.EmailMassage = 'Invalid email format';
        } else {
            error.EmailMassage = null;
        }
    },
    handleMessage = () => {
        if (message.trim().length < messageLenth) {
            error.Message = `Message should be at least ${messageLenth} characters`;
        } else {
            error.Message = null;
        }
    },
    submitForm = async (data) => {
        if (areErrors()) {
            return
        }
        
        btnDisabled = true;
        const fetchData = {
            method: 'POST', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            body: data
        };
        
        const response = await fetch("contact-form", fetchData);

        if (response.ok) {
            isSubmited = true;
            isSubmissionError = false;
        } else {
            // if error 
            isSubmited = true;
            isSubmissionError = true;
        }
    }
</script>

{#if isSubmited === false}
    <div class="form" out:blur|local="{{ duration: 400, quintIn }}">
        <form id="contact-form" on:submit|preventDefault={ handleSubmit } bind:this={ form }>
            <div class="form_lines">
                <label for="n">Name:</label>
                <input id="n" type="text" name="n" class="input" maxlength="36" placeholder="Your Name" title="Your Name" required bind:value={ name } on:input={ handleName }>
            </div>
            {#key error.NameMassage}
                <div class="text-center error_message" transition:slide|local>
                    {#if error.NameMassage && name != ''}
                        { error.NameMassage }
                    {/if}
                </div>
            {/key}
            <div class="form_lines">
                <label for="n">E-mail:</label>
                <input id="e" class="input" name="e" maxlength="40" placeholder="Your E-mail" title="Your E-mail" required bind:value={ email } on:input={ handleEmail }>
            </div>
            {#key error.EmailMassage}
                <div class="text-center error_message" transition:slide|local>
                    {#if error.EmailMassage && email != ''}
                        { error.EmailMassage }
                    {/if}
                </div>
            {/key}
            <div class="form_lines">
                <label for="m">Message:</label>
                <textarea id="m" name="m" maxlength="500" placeholder="Enter your message" rows="8" title="Enter your message" required bind:value={ message } on:input={ handleMessage }></textarea>
            </div>
            {#key error.Message}
                <div class="text-center error_message" transition:slide|local>
                    {#if error.Message && message != ''}
                        { error.Message }
                    {/if}
                </div>
            {/key}
            <div class="text-center form_lines">
                <input type="submit" value="SEND" title="Submit" disabled="{ btnDisabled }">
            </div>    
        </form>
        
    </div>
{:else}
    <Status { isSubmissionError } />
{/if}

<style lang="scss">
    .form{
        margin-top: 2rem;
    }
    .form_lines, .error_message{
        margin-bottom: 0.75rem;
    }
    .error_message{
        font-size: 0.8rem;
    }
</style>